import {MouseEvent} from "react";

export function disablePropagationHandler(e: MouseEvent): void{
    e.stopPropagation();
}
